import React, { FC } from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources, AppPermissions } from '@erecruit/types';
import { Authorize } from '@erecruit/modules';
import { CustomFieldRenderer } from '@erecruit/modules';
import SectionContextMenu from '../SectionContextMenu';
import { BaseSectionProps } from '../../types';

const { FormattedMessage } = Intl;

const AdditionalInfoSection: FC<BaseSectionProps<
  Resources.CustomField[]
>> = props => {
  const { data, expanded, isMyOwn, onEdit } = props;

  return (
    <FlexItem>
      <CardInfo
        showDetails={expanded}
        title={
          <H3 align="center">
            <FormattedMessage
              id={messageIds.vms.positionRecord.additionalInfo.title}
            />
          </H3>
        }
        extra={
          <Authorize
            permission={`(${AppPermissions.EditPositions} | (${AppPermissions.EditMyOwnPositions} & ${isMyOwn})) & ${AppPermissions.EditPositionAdditionalInfo}`}
          >
            <SectionContextMenu section="additionalInfo" onEdit={onEdit} />
          </Authorize>
        }
      >
        {data.map(customField => (
          <CardInfoItem
            key={customField.id}
            label={customField.name}
            type={CardInfoValueType.Custom}
            value={
              <H3>
                <CustomFieldRenderer
                  mode="view"
                  {...customField}
                  value={customField.value}
                />
              </H3>
            }
          />
        ))}
      </CardInfo>
    </FlexItem>
  );
};

export default AdditionalInfoSection;
